import { Breadcrumb } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ADMIN, GAME_MASTER } from './Roles';
import { useAuth } from "./AuthProvider";

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const auth = useAuth();
  const show = auth.roles?.includes(ADMIN);

  if (!show) {
      return null;
  }

  return (
    <Breadcrumb>
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const key = `paths.${value}`;
        const translated = i18n.exists(key) ? t(key) : value
        return (
          <Breadcrumb.Item key={to} linkAs={Link} linkProps={{ to }}>
            {translated}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
}

export default Breadcrumbs;